<template>
  <div class="chat_wrap">
    <div v-if="messages.length">
      <div class="" v-for="message in messages" v-bind:key="message._id">
        <p class="time" v-if="message.timestamp">
          {{ timeStamp(message.timestamp) }}
        </p>

        <div
          class="message"
          :class="{
            owner:
              $store.state.meeting.localParticipant.user_id ===
              message.from._id,
          }"
        >
          <div class="name" :title="message.from.username">
            {{ message.from.username.match(/\b(\w)/g).join("") }}
          </div>

          <div class="msg_text">
            <div v-if="message.html" v-html="message.html" />
            <p v-else>{{ message.text }}</p>

            <ul>
              <li
                v-for="attachment in message.attachments"
                v-bind:key="attachment._id"
                class="attachment_link"
              >
                <a
                  v-bind:href="attachment.downloadUrl"
                  download
                  class="hover_op"
                  :title="attachment.fileName"
                >
                  <template>
                    <img
                      width="32"
                      height="32"
                      v-if="attachment.contentType.startsWith('image')"
                      :src="attachment.downloadUrl"
                      alt=""
                    />
                    <div
                      v-else
                      :style="{
                        width: '32px',
                        height: '32px',
                        display: 'inline-block',
                        background: 'black',
                      }"
                    />
                  </template>

                  <span>{{ attachment.fileName }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="empty_chat">No messages yet.</div>

    <message-list :messages="messages" />
    <message-input />
  </div>
</template>

<script>
import MessageList from "../meeting/MessageList.vue";
import MessageListItem from "../meeting/MessageListItem.vue";
import MessageInput from "../chat/MessageInput.vue";
import ChatInput from "../meeting/ChatInput.vue";

export default {
  name: "Chat",
  computed: {
    localParticipant() {
      return this.$store.state.meeting.localParticipant;
    },
    messages() {
      return this.$store.state.meeting.messages;
    },
  },
  props: ["roomId", "meetingId"],
  created() {},
  methods: {
    timeStamp(data) {
      return this.$moment(data).calendar();
    },
  },
  updated() {
    this.$emit("scrollChat");
  },
  components: { MessageList, MessageInput, MessageListItem, ChatInput },
};
</script>

<style lang="scss">
.chat_wrap {
  display: flex;
  flex-direction: column;
  min-height: 100%;

  .empty_chat {
    flex: 1 1 100%;
    justify-content: center;
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    display: flex;
    align-items: center;
  }
}

.time {
  opacity: 0.64;
  color: #000;
  font-family: "Nunito Sans", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  margin-bottom: 16px;
  padding-left: 80px;
}

.mention {
  color: #000;
}

.owner {
  .mention {
    color: #fc5a12;
  }
}

.msg_text {
  padding: 16px;
  border-radius: 0 16px 16px;
  background-color: #fc5a12;
  color: #fff;
  font-family: "Nunito Sans", sans-serif;
  font-size: 16px;
  font-weight: 700;
  font-style: normal;
  letter-spacing: normal;
  line-height: 0;
  text-align: left;
  max-width: 75%;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: -16px;
    border-top: 8px #fc5a12 solid;
    border-right: 8px #fc5a12 solid;
    border-bottom: 8px #fff solid;
    border-left: 8px #fff solid;
  }

  p,
  div {
    line-height: 24px;
    word-break: break-all;

    & + ul {
      margin-top: 10px;
    }
  }

  ul {
    list-style: none;

    &:empty {
      display: none;
    }

    .attachment_link {
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 24px;

      & + .attachment_link {
        margin-top: 8px;
      }

      a {
        color: #fff;
        display: flex;
        align-items: center;

        img,
        div {
          width: 24px;
          height: 24px;
          border-radius: 6px;
          margin-right: 16px;
          flex: none;
        }

        span {
          display: inline;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}

.message .name {
  cursor: default;
  color: #fff;
  flex: none;
  margin-right: 32px;
  width: 48px;
  height: 48px;
  border-radius: 16px;
  background-color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  font-size: 20px;
  font-family: "Playfair Display", serif;
  font-weight: 400;
  line-height: 28px;
  text-transform: uppercase;
}

.message {
  display: flex;
  margin-bottom: 16px;

  &.owner {
    justify-content: flex-end;

    .name {
      display: none;
    }

    .msg_text {
      border-radius: 16px 0 16px 16px;
      background-color: #f9f4ef;
      color: #000;
      font-family: "Nunito Sans", sans-serif;
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      text-align: right;
      margin-right: 16px;

      &:before {
        content: "";
        position: absolute;
        top: 0;
        left: auto;
        right: -16px;
        border-top: 8px #f9f4ef solid;
        border-right: 8px #fff solid;
        border-bottom: 8px #fff solid;
        border-left: 8px #f9f4ef solid;
      }

      .attachment_link a {
        color: #000;
      }
    }
  }
}
</style>
